import React, { useState, useEffect, useContext } from "react";
import "./binExpandable.css";
import HierarchyLines from "../../../../TestLine/HierarchyLines";
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import {
  localStorageGet,
  localStorageRemove,
  localStorageSave,
} from "../../../../services/localStorageService";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES, LABELS } from "../../../../globals/globals";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { DialogContext } from "../../../../contexts/DialogContext";
import { DeleteBinModal } from "./DeleteBinModal/DeleteBinModal";
import { deleteBin, getBin, UpdateBin } from "../../services/locationsConfigurationService";
import { getUserCompanyId } from "../../../../services/authService";
import Input from '../../../../components/Inputs/Input';
import { set } from "react-hook-form";
import { LocationsContext } from "../../contexts/LocationsContext";

const binDraftPrefix = "configuration/locationConfiguration/draft/bins/";

const typeMeasurementMap = {
  Meters: "m",
  Centimeters: "cm",
  Millimeters: "mm",
  Inches: "in",
  Feet: "ft",
}
export const BinExpandable = ({
  idx,
  length,
  isDraft = false,
  isNewBin = false,
  reload = "",
  locationId,
  siteId,
  rackId,
  shelfId,
  informationOfDraft,
  bigParentListLenght,
  parentListLength,
  binBasicInfo,
}) => {
  // const [isOpen, setIsOpen] = useState(false);
  // const [editionMode, setEditionMode] = useState(false);
  const [viewMode, setViewMode] = useState('closed');
  const [isExpanded, setIsExpanded] = useState(false);

  const [nameValue, setNameValue] = useState(binBasicInfo?.name ? binBasicInfo.name : "");
  const [lengthValue, setLengthValue] = useState(binBasicInfo?.length ? binBasicInfo.length : "");
  const [widthValue, setWidthValue] = useState(binBasicInfo?.width ? binBasicInfo.width : "");
  const [depthValue, setDepthValue] = useState(binBasicInfo?.depth ? binBasicInfo.depth : "");
  const [UOMName, setUOMName] = useState(binBasicInfo?.uomName ? binBasicInfo.uomName : "")

  const [draft, setDraft] = useState(isDraft);
  const [newBin, setNewBin] = useState(isNewBin);
  const [binCompleteData, setBinCompleteData] = useState(null);
  const [binDataInDraft, setBinDataInDraft] = useState(null);
  const { warningMsg, successMsg } = useSnackBar();
  const [hasNameError, setHasNameError] = useState(false);
  const [UOMDropdownConfig, setUOMDropdownConfig] = useState(null);
  const openLocationId = useSelector((state) => state.locationSites.openLocationId);
  const [filtersToMeasurements, setFiltersToMeasurements] = useState(null)
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [preselectUOM, setPreselectUOM] = useState(null)
  const [UOM, setUOM] = useState("");
  const [version, setVersion] = useState(0)
  const { draftStatusChanged, setDraftStatusChanged } = useContext(LocationsContext)

  const deleteThisBin = async () => {
    let request = await deleteBin(binBasicInfo.id)
    if (request.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
      localStorageRemove(binDraftPrefix, { binId: binBasicInfo.id });
      setDraftStatusChanged(!draftStatusChanged)

      successMsg("Bin deleted", "The bin was deleted successfully");
      closeDialog();
      if (reload) {
        reload();
      }
    }
  }

  const openDeleteBinDialog = () => {
    openDialog({
      component: DeleteBinModal,
      props: {
        binName: binBasicInfo.name,
        binDescription: binBasicInfo.description,
        onClose: closeDialog,
        deletebin: deleteThisBin,
      },
    });
  };

  const validateFields = () => {
    let isValid = true;

    if (!nameValue.trim()) {
      setHasNameError(true);
      isValid = false;
    } else {
      setHasNameError(false);
    }

    // if (lengthValue == null || lengthValue == undefined || lengthValue == "" || lengthValue < 0) {
    //   setHasLengthError(true);
    //   isValid = false;
    // } else {
    //   setHasLengthError(false);
    // }

    // if (widthValue == null || widthValue == undefined || widthValue == "" || widthValue < 0) {
    //   setHasWidthError(true);
    //   isValid = false;
    // } else {
    //   setHasWidthError(false);
    // }

    // if (depthValue == null || depthValue == undefined || depthValue == "" || depthValue < 0) {
    //   setHasDepthError(true);
    //   isValid = false;
    // } else {
    //   setHasDepthError(false);
    // }

    if (!isValid) {
      warningMsg("Fields required", "Certain empty fields or negative numbers are not allowed");
    }

    return isValid;
  };

  const saveBin = async (typeOfFinish = "") => {
    if (!validateFields()) {
      return;
    }

    if (typeOfFinish === "end") {
      let { UOMName, ...dataWithOutUOMName } = binDataInDraft
      let request = await UpdateBin(dataWithOutUOMName);

      if (request.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
        successMsg("Bin updated", "The bin was updated successfully");
        setBinCompleteData(request.data.load)
        localStorageRemove(binDraftPrefix, { binId: binBasicInfo.id });
        setDraftStatusChanged(!draftStatusChanged)

        setDraft(false);
        setNewBin(false);
        setIsExpanded(false);
        setViewMode("closed");
        setTimeout(() => {
          if (reload) {
            reload();
          }
        }, 100);
      }

    } else {

      let { UOMName, ...dataWithOutUOMName } = binDataInDraft
      let request = await UpdateBin(dataWithOutUOMName);
      if (request.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
        setDraft(true);
        setNewBin(false);
        // setIsExpanded(true);
        // setViewMode("edit");
        successMsg("Bin updated", "The bin was updated successfully , you can continue editing.");
        setVersion(request.data.load.version)
        setBinDataInDraft(() => {
          let unitsOfMeasureIdTarget = "UOM.id"

          const updatedData = {
            version: request.data.load.version,
            id: request.data.load.id,
            name: nameValue,
            // description: descriptionValue,
            length: lengthValue,
            width: widthValue,
            depth: depthValue,
            unitsOfMeasureId: UOM[unitsOfMeasureIdTarget],
            shelfId: shelfId,
            companyId: getUserCompanyId(),
            status: "Active"
          }
          return updatedData;
        })
      }

    }
  };

  const cancelBinEdition = () => {
    // setNameValue(binCompleteData?.name || "");
    // setDescriptionValue(binCompleteData?.description || "");
    // setLengthValue(binCompleteData?.length || "");
    // setWidthValue(binCompleteData?.width || "");
    // setDepthValue(binCompleteData?.depth || "");
    localStorageRemove(binDraftPrefix, {
      binId: binBasicInfo.id,
    });
    setDraftStatusChanged(!draftStatusChanged)

    setIsExpanded(false);
    setViewMode("closed");
    setDraft(false);
    if (reload) {
      reload();
    }
  };

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    {
      label: "Save and Continue Editing",
      icon: "icon-save",
      id: "save-continue",
    },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => saveBin("end"),
    "save-continue": () => saveBin("continue"),
    cancel: () => cancelBinEdition(),
  };

  const getUOMDropdownConfig = async () => {
    let dropdownId = 40;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setUOMDropdownConfig(request.data.load);
    }
  };

  const saveInDraft = () => {
    if (binDataInDraft !== null && viewMode == "edit") {
      localStorageSave(binDraftPrefix, { locationId: locationId, siteId: siteId, rackId: rackId, shelfId: shelfId, binId: binBasicInfo.id }, binDataInDraft);
      setDraftStatusChanged(!draftStatusChanged)
    }
  };


  useEffect(() => {
    if (isExpanded && viewMode == "edit" && binCompleteData) {
      setBinDataInDraft(() => {
        let unitsOfMeasureIdTarget = "UOM.id"

        const updatedData = {
          version: version,
          id: parseInt(binBasicInfo.id),
          name: nameValue,
          // description: descriptionValue,
          length: parseInt(lengthValue),
          width: parseInt(widthValue),
          depth: parseInt(depthValue),
          unitsOfMeasureId: UOM?.[unitsOfMeasureIdTarget] ? UOM?.[unitsOfMeasureIdTarget] : null,
          shelfId: parseInt(shelfId),
          accountId: parseInt(localStorage.getItem("u_account_id")),
          status: "Active",
          UOMName: UOMName
        }
        return updatedData;
      })
    }
  }, [nameValue, lengthValue, widthValue, depthValue, UOM, version, UOMName])


  const getBinInfo = async () => {
    let reques = await getBin(binBasicInfo.id)
    if (reques.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setBinCompleteData(reques.data.load)
    }
  }

  useEffect(() => saveInDraft(), [binDataInDraft])

  useEffect(() => {
    if (informationOfDraft) {
      setNameValue(informationOfDraft.name || "");
      setLengthValue(informationOfDraft.length || "");
      setWidthValue(informationOfDraft.width || "");
      setDepthValue(informationOfDraft.depth || "");
      setPreselectUOM(informationOfDraft.unitsOfMeasureId || "")
      setUOM(informationOfDraft?.unitsOfMeasureId ? {
        "UOM.id": informationOfDraft.unitsOfMeasureId
      } : "")
      setUOMName(informationOfDraft?.UOMName || "")
      setVersion(informationOfDraft.version || 0)
    } else if (binCompleteData) {
      setNameValue(binCompleteData?.name ? binCompleteData?.name : "");
      setLengthValue(binCompleteData?.length ? binCompleteData?.length : "")
      setWidthValue(binCompleteData?.width ? binCompleteData?.width : "");
      setDepthValue(binCompleteData?.depth ? binCompleteData?.depth : "");
      setPreselectUOM(binCompleteData?.unitsOfMeasureId ? binCompleteData?.unitsOfMeasureId : "")
      setUOM(binCompleteData?.uomIdm ? { "UOM.id": binCompleteData.uomIdm } : "")
      setVersion(binCompleteData?.version || 0)
    }
  }, [informationOfDraft, binCompleteData]);


  useEffect(() => {
    if (newBin == true) {
      setViewMode("edit");
      setIsExpanded(true);
    }
  }, []);

  useEffect(() => {
    if (!UOMDropdownConfig && isExpanded) {
      getUOMDropdownConfig();
    }

    if (isExpanded) {
      getBinInfo()
    }
  }, [isExpanded]);

  useEffect(() => {
    if (binCompleteData !== null) {
      if (informationOfDraft) {
        setPreselectUOM(informationOfDraft?.unitsOfMeasureId || "")
      } else {
        setPreselectUOM(binCompleteData?.unitsOfMeasureId || "")
      }
    }
  }, [binCompleteData])

  useEffect(() => {
    setFiltersToMeasurements(() => {
      return [
        { columnName: "l.id", value: openLocationId },
        { columnName: "measure_type", value: "length" },
        { columnName: "context", value: "bin" }
      ]
    })
  }, [openLocationId])

  const getUOMSelection = (value) => {
    setUOM(() => {
      return value
    });
    setUOMName(value["UOM.name"])
  }

  const handleHeaderClick = () => {
    if (viewMode === 'edit') return;

    if (viewMode !== 'closed') {
      setViewMode('closed');
      setIsExpanded(false);
    } else {
      setViewMode('form');
      setIsExpanded(true);
    }
  };


  const handleEditClick = (e) => {
    e.stopPropagation();
    setViewMode('edit');
    setIsExpanded(true);
    setDraft(true)
  };

  function getMeasurementText(length, width, depth, UOM, typeMeasurementMap, binBasicInfo) {

    const measures = [length, width, depth].filter(measure =>
      measure !== null && measure !== undefined && measure !== ''
    );
    const uom = typeMeasurementMap[UOM?.['UOM.name']] ? typeMeasurementMap[UOM?.['UOM.name']] : typeMeasurementMap[UOMName] ? typeMeasurementMap[UOMName] : binBasicInfo?.uomAbreviation || '';

    if (measures.length === 0 && uom) return uom;

    if (measures.length === 0) return '';

    let result = measures.join(' × ');

    if (uom) {
      result += (result.endsWith(' ') ? '' : '') + uom;
    }

    return result;
  }

  const handleUOMClear = () => {
    setUOM(null)
    setPreselectUOM(null)
  }
  return (
    <>
      <section
        className="bin-grey-bg"
        style={{
          background: viewMode == "edit" ? "var(--white-100)" : viewMode == "form" ? "var(--white-100)" : "",
          border: viewMode == "edit" ? "1px solid #AFAFAF" : viewMode == "form" ? "1px solid #AFAFAF" : "",
          zIndex: viewMode == "edit" ? 5 : 1,
        }}
      >
        {bigParentListLenght > 1 && (
          <HierarchyLines
            idx={-1}
            totalLength={1}
            depth={0}
            noChild={false}
            initialTop={62}
          ></HierarchyLines>
        )}
        {parentListLength > 1 && (
          <HierarchyLines
            idx={-1}
            totalLength={1}
            depth={1}
            noChild={false}
            initialTop={62}
          ></HierarchyLines>
        )}
        <HierarchyLines
          idx={0}
          totalLength={1}
          depth={2}
          initialTop={62}
        // zIndex=
        ></HierarchyLines>
        <section
          className="bin-expandable-header"
          onClick={handleHeaderClick}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleHeaderClick()
            }
          }}
          style={{
            backgroundColor: viewMode === 'form' ? 'transparent' : viewMode === 'edit' ? 'transparent' : '',
            border: viewMode === 'form' ? 'none' : viewMode === 'edit' ? 'none' : viewMode == "closed" ? "1px solid #E6E6E6" : 'none',
          }}
        >
          {(newBin || draft) && (
            <div className="draft-bin-span">{LABELS.DRAFT}</div>
          )}

          <span></span>
          <h4>Bin</h4>
          <p style={{
            // maxWidth: "15.3%",
            width: "22.5%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            minWidth: "5rem",
          }}>
            Name <Tooltip title={nameValue?.toUpperCase()} arrow>
              <span className="ellipsis">{nameValue || "--"}</span>
            </Tooltip>
          </p>

          <p style={{
            width: "20%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            minWidth: "5rem",
          }}>
            Measurements{" "}
            <Tooltip
              title={getMeasurementText(lengthValue, widthValue, depthValue, UOM, typeMeasurementMap, binBasicInfo)}
              arrow
            >
              <span className="ellipsis">
                {getMeasurementText(lengthValue, widthValue, depthValue, UOM, typeMeasurementMap, binBasicInfo) ? getMeasurementText(lengthValue, widthValue, depthValue, UOM, typeMeasurementMap, binBasicInfo) : "--"}
              </span>
            </Tooltip>
          </p>

          <div className="actions-section-sitesExp">
            {viewMode !== "edit" && (
              <Tooltip title="edit bin" arrow>
                <button
                  onClick={(e) => {
                    handleEditClick(e);
                  }}>
                  <i

                    className="icon-edit"
                    style={{
                      fontSize: "1rem",
                      color: "var(--grey-200)",
                    }}
                  />
                </button>
              </Tooltip>
            )}
            <Tooltip title="delete bin" arrow>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  openDeleteBinDialog()
                }}
              >
                <i

                  className="icon-delete-new"
                  style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }}
                />
              </button>
            </Tooltip>
            {viewMode == "edit" && (
              <MultioptionButton
                buttons={multiOptionsBtn}
                buttonCallbacks={buttonsCallback}
              />
            )}
          </div>
        </section>
        <section className={`bin-expandable-content ${isExpanded ? "open" : ""}`}>
          {viewMode == "edit" ? (
            <section className="bin-edit-form">
              <div className="bin-inp-cont">
                <Input
                  label="Name"
                  value={nameValue}
                  onChange={(e) => {
                    setNameValue(e.target.value);
                    setHasNameError(false);
                  }}
                  error={hasNameError}
                  upperCase={true}
                />

              </div>
              <div className="bin-measurements">
                <div className="bin-measures-inp-cont">
                  <div className="uom-drop-cont">
                    {UOMDropdownConfig && (
                      <Dropdowns handleClear={handleUOMClear} preSelectValue={preselectUOM} onOptionSelect={getUOMSelection} data={UOMDropdownConfig} dropdownFilters={filtersToMeasurements} />
                    )}
                  </div>
                  <Input
                    isNumeric={true}
                    label="Length"
                    value={lengthValue}
                    onChange={(e) => {
                      setLengthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}

                  />
                  <i className="icon-cross"></i>
                  {/* <p>Width</p> */}
                  <Input
                    isNumeric={true}
                    label="Width"
                    value={widthValue}
                    onChange={(e) => {
                      setWidthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}

                  />
                  <i className="icon-cross"></i>
                  {/* <p>Depth</p> */}
                  <Input
                    isNumeric={true}
                    label="Depth"
                    value={depthValue}
                    onChange={(e) => {
                      setDepthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}

                  />
                </div>
              </div>
            </section>
          ) : viewMode == "form" ? (
            <section className="bin-edit-form">
              <div className="bin-inp-cont">
                <Input
                  label="Name"
                  value={nameValue}
                  onChange={(e) => {
                    setNameValue(e.target.value);
                    setHasNameError(false);
                  }}
                  error={hasNameError}
                  upperCase={true}
                  disabled={true}
                />

              </div>
              <div className="bin-measurements">
                {/* <p>Measurements</p> */}
                <div className="bin-measures-inp-cont">
                  <div className="uom-drop-cont">
                    {UOMDropdownConfig && (
                      <Dropdowns handleClear={handleUOMClear} disabled={true} preSelectValue={preselectUOM} onOptionSelect={getUOMSelection} data={UOMDropdownConfig} dropdownFilters={filtersToMeasurements} />
                    )}
                  </div>
                  {/* <p>Length</p> */}
                  <Input
                    isNumeric={true}
                    label="Length"
                    value={lengthValue}
                    onChange={(e) => {
                      setLengthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disabled={true}

                  />
                  <i className="icon-cross"></i>
                  <Input
                    isNumeric={true}
                    label="Width"
                    value={widthValue}
                    onChange={(e) => {
                      setWidthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disabled={true}

                  />
                  <i className="icon-cross"></i>
                  <Input
                    isNumeric={true}
                    label="Depth"
                    value={depthValue}
                    onChange={(e) => {
                      setDepthValue(e.target.value);
                    }}
                    style={{
                      width: "15%"
                    }}
                    upperCase={true}
                    disabled={true}

                  />
                </div>
              </div>
            </section>
          ) : ""}
        </section>
      </section>
    </>
  );
};
